<div class="modal-body-content container-with-footer">
    <div class="inner-container container-scroll" *ngIf="registers != null">
        <div
            class="alert alert-info"
            role="alert"
            *ngIf="registers != null && registers.length === 0 && !working"
        >
            This person has no current registers to display.
        </div>

        <ng-container *ngFor="let register of registers">
            <h4
                class="section-heading"
                [ngStyle]="{
                    'margin-bottom: 0': register.missionTimeDetails.length
                }"
            >
                <span>
                    {{ register.registerName }}
                </span>
                <div></div>
                <a
                    *ngIf="canEdit && canAdminOrganisation && register.canView"
                    (click)="!working ? showRegister(register) : null"
                >
                    View Register
                </a>
            </h4>
            <p *ngIf="register.missionTimeDetails.length" class="subtitle">
                {{ register.missionTimeDetails }}
            </p>
            <div
                class="table-container table-borderless"
                *ngFor="let condition of register.conditions"
            >
                <table class="table">
                    <thead>
                        <tr>
                            <th class="status-column">Status</th>
                            <th *ngFor="let check of condition.checks">
                                {{ check.heading }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style="padding: 10px 0" class="status-column">
                                <register-status-display
                                    [status]="condition.status"
                                ></register-status-display>
                            </td>
                            <td *ngFor="let check of condition.checks">
                                <span
                                    *ngIf="check.checked === true"
                                    class="fa fa-check green-tick"
                                >
                                </span>
                                <span
                                    *ngIf="check.checked === false"
                                    class="red-cross"
                                >
                                    X
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <personnel-currency
                *ngIf="register && hasCurrency"
                [personId]="personId"
                [managingOrganisationId]="managingOrganisationId"
                [personnelRegisterId]="register.authorityRegisterId"
            ></personnel-currency>
        </ng-container>

        <loading-indicator [isLoading]="working"></loading-indicator>
    </div>
    <div class="action-container" *ngIf="canEdit">
        <button
            type="button"
            class="btn btn-primary"
            (click)="showAddToRegisterDialogue()"
            [disabled]="working"
        >
            Add to Register
        </button>
    </div>
</div>
